import FormValidator from "../form-validation/formvalidator";

if (document.querySelector('.div-custom-radio')) {
    let listInputRadioAll = document.querySelectorAll('.div-custom-radio');
    listInputRadioAll.forEach((el) => {
        if (el.querySelectorAll('label')) {
            let listLabel = el.querySelectorAll('label')
            listLabel.forEach((label) => {
                label.classList.add('noClick');
            });
        }
    });
    listInputRadioAll.forEach((parent) => {
        let listInput = parent.querySelectorAll('input');
        let listLabel = parent.querySelectorAll('label');
        listInput.forEach(input => {
            input.addEventListener('change', function () {
                listLabel.forEach(el => {
                    el.classList.remove('noClick');
                });
            });
        });
    });
}


if (document.querySelector('.extra-input-radio')) {
    let formvalidator = new FormValidator(document.querySelector('.extra-input-radio').closest('form'), false);
    let listExtraInput = document.querySelectorAll('.extra-input-radio');

    listExtraInput.forEach(element => {
        element.disabled = true;

        let radioGroup = element.closest('.form-group');

        let radioInputs = radioGroup.querySelectorAll('input[type="radio"]');
        let checkboxInputs = radioGroup.querySelectorAll('input[type="checkbox"]');

        let checkboxesAndRadios = Array.from(radioInputs).concat(Array.from(checkboxInputs));
        let radioInputsExtra = element.parentElement.querySelector('input[type="text"]');

        checkboxesAndRadios.forEach(field => {
            field.addEventListener('change', function () {
                let getName = element.name;
                getName = getName.replace(/setter-/g, "");

                // console.log("Typ pola: " + field.type)
                // console.log(field)

                let hideableInput = document.querySelector(`[name="${getName}"]`);

                if (hideableInput) {
                    if (field.value === radioInputsExtra.getAttribute('value-radio')) {

                        if (field.type === 'checkbox') {
                            if (element.disabled && field.checked) {

                                showHideableInput(element, hideableInput, radioInputsExtra);
                            } else {
                                hideHideableInput(element, hideableInput, radioInputsExtra);
                            }
                        } else if (field.type === 'radio') {
                            showHideableInput(element, hideableInput, radioInputsExtra);
                        }
                    } else if (field.type === 'radio') {

                        hideHideableInput(element, hideableInput, radioInputsExtra);

                    }
                    formvalidator.checkValidationType(element);
                }
            });
        });

    });
}

function showHideableInput(element, hideableInput, radioInputsExtra) {
    element.disabled = false;
    if (hideableInput.getAttribute('copyclass')) {
        hideableInput.getAttribute('copyclass').split(' ').forEach(className => {
            if (className !== '') {
                element.classList.add(className);
            }
        });
    }

    if (hideableInput.getAttribute('data-initial-constraints')) {
        element.setAttribute('data-initial-constraints', hideableInput.getAttribute('data-initial-constraints'))
    }
    if (hideableInput.getAttribute('required')) {
        element.setAttribute('required', hideableInput.getAttribute('required'))
    }
}

function hideHideableInput(element, hideableInput, radioInputsExtra) {
    // console.log("sprawdz  czy powinno się zmienić" + element.name + " " + radioInputsExtra.getAttribute('value-radio'));
    // console.log(element.value + " -  " + element.disabled);

    element.disabled = true;
    element.value = '';
    element.classList.remove('required');

    if (hideableInput.getAttribute('copyclass')) {
        hideableInput.getAttribute('copyclass').split(" ").forEach(className => {
            if (className !== '') {
                element.classList.remove(className);
            }
        });
    }
    if (element.getAttribute('data-initial-constraints')) {
        element.removeAttribute('data-initial-constraints');
    }
    if (element.getAttribute('required')) {
        element.removeAttribute('required')
    }


}